module.exports = __webpack_public_path__ + "img/videowiki-cast.20c0af1b.svg";